const ToggleModal = () => {
    let modal = document.getElementById("modalMenu");
    let burger = document.getElementById("burger");
    let phoneNum = document.getElementById("phoneNum");

    if(!modal.style.display || modal.style.display === "none"){
      modal.style.display = "flex";
      phoneNum.style.display="none";
      burger.classList.add("close");
      burger.classList.remove("open");
      document.body.style.overflow = "hidden"; 
      modal.style.overflow = ""; 
    }else if(modal.style.display === "flex"){
      modal.style.display = "none";
      phoneNum.style.display="flex";
      burger.classList.add("open");
      burger.classList.remove("close");
      document.body.style.overflow = ""; 
      modal.style.overflow = "hidden"; 
    }
  };

  export default ToggleModal;